import { render, staticRenderFns } from "./TemplatesView.vue?vue&type=template&id=e21ec0c0&"
import script from "./TemplatesView.vue?vue&type=script&lang=ts&"
export * from "./TemplatesView.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesView.vue?vue&type=style&index=0&id=e21ec0c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports